import { Pipe, PipeTransform } from '@angular/core';

import { DATE_TIME_LOCALE } from '../models/constants';
import {
  Formats,
  predefinedDateTimeFormats,
} from '../models/date-time-formats';

// This pipe INTENTIONALLY restricts the use of the DatePipe to a few pre-defined formats
// As a rule of thumb...
// Use 'medium' within Diagnostics to show operations down to the second
// Use 'short' outside of diagnostics to show both date and time
// Use 'shortDate' to show just the date
// Use 'shortTime' to show just the time

@Pipe({
  name: 'displayDateTime',
  standalone: true,
})
export class DisplayDateTimePipe implements PipeTransform {
  transform(
    value: Parameters<Intl.DateTimeFormat['format']>[0],
    format: Formats = 'short'
  ) {
    return new Intl.DateTimeFormat(
      DATE_TIME_LOCALE,
      predefinedDateTimeFormats[format]
    ).format(value);
  }
}
